import { useSectionEffectsContext } from "@ecp-boxes/structure/Contexts/SectionEffectsContext";
import { useTheme } from "styled-components";
import { IThemeState } from "@ecp-redux/dto/themeSettings/themeSettings.types";

type ScrollOptions = {
  offset?: number;
  behavior?: ScrollBehavior;
  useStickyHeader?: boolean;
};

type ScrollToElementHook = (
  element: HTMLElement | null,
  options?: ScrollOptions
) => void;

const useScrollIntoElement = (): ScrollToElementHook => {
  const { totalHeaderStickyElementsHeight } = useSectionEffectsContext();
  const theme = useTheme() as IThemeState;
  const { stickyHeader } = theme.stylePages.pages.headerFooter;

  const scrollToElement: ScrollToElementHook = (
    element: HTMLElement | null,
    options: ScrollOptions = {}
  ) => {
    const { offset = 0, behavior = "smooth" } = options;

    const scrollWrapper = document?.getElementById("scroll-wrapper");
    if (!element || !scrollWrapper) return;

    const elementPosition = element.getBoundingClientRect().top;
    const headerElement = document?.getElementById("header");
    const headerHeight = stickyHeader ? (headerElement?.offsetHeight ?? 0) : 0;
    const stickyOffset = totalHeaderStickyElementsHeight + headerHeight;
    const totalOffset = stickyOffset + offset;

    const targetScroll =
      elementPosition + scrollWrapper.scrollTop - totalOffset;

    scrollWrapper.scrollTo({
      top: targetScroll,
      behavior,
    });
  };

  return scrollToElement;
};

export default useScrollIntoElement;
